<template>
  <div id="spinner" />
</template>

<script>
export default {
  name: 'Loader'
};
</script>

<style scoped>

@keyframes spinner {
  from {
    transform: rotate(0deg);
  } to {
    transform: rotate(360deg);
  }
}

#spinner {
  min-width: 40px;
  min-height: 40px;
  border: 5px solid rgba(255,255,255,.1);
  border-right: 5px solid #3996fb;
  border-radius: 50%;
  animation: spinner 1s linear infinite;
}
</style>
